module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/HotDay/Tokyo_HotDay_MRI_RCP85_End.png";